import { Injectable } from '@angular/core';

const DARK_LINK_ID = 'ng-zorro-dark-theme';
const DARK_CSS_PATH = 'ng-zorro-antd/ng-zorro-antd.dark.min.css';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private isDark = false;

  constructor() {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      this.enableDark();
    }
  }

  toggle(): void {
    if (this.isDark) {
      this.enableLight();
    } else {
      this.enableDark();
    }
  }

  isDarkMode(): boolean {
    return this.isDark;
  }

  private enableDark(): void {
    this.isDark = true;
    localStorage.setItem('theme', 'dark');
    document.body.classList.add('dark-theme');

    if (!document.getElementById(DARK_LINK_ID)) {
      const link = document.createElement('link');
      link.id = DARK_LINK_ID;
      link.rel = 'stylesheet';
      link.href = DARK_CSS_PATH;
      document.head.appendChild(link);
    }
  }

  private enableLight(): void {
    this.isDark = false;
    localStorage.setItem('theme', 'light');
    document.body.classList.remove('dark-theme');

    document.getElementById(DARK_LINK_ID)?.remove();
  }
}
